// extracted by mini-css-extract-plugin
export default {"signInButton":"styles_signInButton__FjgNd"};